import {Telefone} from './telefone';
import {UsuarioService} from '../../usuario/usuario.service';
import {TelefoneUsuario} from './telefone-usuario';
import {EnderecoUsuario} from './endereco-usuario';
import {StringValidacao} from './string';
import {Endereco} from './endereco';
import {Construtor} from './construtor';
import { RoleUsuario } from './role-usuario';

export class Usuario implements Construtor<Usuario> {

  public idUsuario: number;
  public nomeUsuario: string;
  public email: string;
  public senha: string;
  public cargo: string;
  public idCliente: number;
  public foto: string;
  public uid: string;
  public idAreaCliente: number;
  public enderecosUsuario: EnderecoUsuario[];
  public telefonesUsuario: TelefoneUsuario[];
  public rolesUsuario: RoleUsuario[];

  constructor(object?: any) {

    this.enderecosUsuario = new Array<EnderecoUsuario>();
    this.telefonesUsuario = new Array<TelefoneUsuario>();
    this.rolesUsuario = new Array<RoleUsuario>();

    if (object !== undefined) {

      if (object instanceof Usuario) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;

  }

  get obterIdUsuario(): number {
    return this.idUsuario;
  }

  set IdUsuario(idUsuario: any) {
    this.idUsuario = idUsuario;
  }

  get obterNomeUsuario(): string {
    return this.nomeUsuario.slice(0);
  }

  set NomeUsuario(nomeUsuario: any) {
    this.nomeUsuario = StringValidacao.copiarStringValida(nomeUsuario);
  }

  get obterEmail(): string {
    return this.email;
  }

  set Email(email: any) {
    this.email = StringValidacao.copiarStringValida(email);
  }

  get obterCargo(): string {
    return this.cargo.slice(0);
  }

  set Cargo(cargo: any) {
    this.cargo = StringValidacao.copiarStringValida(cargo);
  }

  get obterIdCliente(): number {
    return this.idCliente;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  get obterFoto(): string {
    return this.foto;
  }

  set Foto(foto: any) {
    this.foto = foto;
  }

  set insertEnderecoUsuario(enderecoUsuario: EnderecoUsuario) {
    if (this.enderecosUsuario === null || this.enderecosUsuario === undefined) {
      this.enderecosUsuario = new Array<EnderecoUsuario>();
    }
    this.enderecosUsuario.push(enderecoUsuario);
  }

  set EnderecosUsuario(enderecosUsuario: any) {

    this.enderecosUsuario = new Array<EnderecoUsuario>();

    if (enderecosUsuario !== undefined) {
      for (const enderecoUsuario of enderecosUsuario) {
        this.insertEnderecoUsuario = new EnderecoUsuario(enderecoUsuario);
      }
    }
  }

  set insertTelefoneUsuario(telefoneUsuario: TelefoneUsuario) {
    this.telefonesUsuario.push(telefoneUsuario);
  }

  set TelefonesUsuario(telefonesUsuario: any) {

    this.telefonesUsuario = new Array<TelefoneUsuario>();

    if (telefonesUsuario !== undefined) {
      for (const telefoneUsuario of telefonesUsuario) {
        this.insertTelefoneUsuario = new TelefoneUsuario(telefoneUsuario);
      }
    }
  }

  get obterTelefonesUsuario(): TelefoneUsuario[] {
    return this.telefonesUsuario;
  }

  get obterEnderecosUsuario(): EnderecoUsuario[] {
    return this.enderecosUsuario;
  }

  copyObject(usuario: Usuario): void {

    this.IdUsuario = usuario.obterIdUsuario;
    this.NomeUsuario = usuario.obterNomeUsuario;
    this.Cargo = usuario.obterCargo;
    this.IdCliente = usuario.obterIdCliente;
    this.Foto = usuario.foto;
    this.Email = usuario.email;
    this.senha = usuario.senha;
    this.uid = usuario.uid;
    this.idAreaCliente = usuario.idAreaCliente;
    this.EnderecosUsuario = usuario.enderecosUsuario;
    this.TelefonesUsuario = usuario.telefonesUsuario;
    this.rolesUsuario = usuario.rolesUsuario;

  }

  parseFromJson(usuario: any): void {

    this.IdUsuario = usuario.idUsuario;
    this.NomeUsuario = usuario.nomeUsuario;
    this.Cargo = usuario.cargo;
    this.IdCliente = usuario.idCliente;
    this.Foto = usuario.foto;
    this.Email = usuario.email;
    this.senha = usuario.senha;
    this.uid = usuario.uid;
    this.idAreaCliente = usuario.idAreaCliente;
    this.EnderecosUsuario = usuario.enderecosUsuario;
    this.TelefonesUsuario = usuario.telefonesUsuario;
    this.rolesUsuario = usuario.rolesUsuario;
  }

  modeloCompleto(): boolean {

    return this.nomeUsuario !== undefined &&
      this.cargo !== undefined &&
      this.idCliente !== undefined &&
      this.email !== undefined;
  }

  getNewInstance(object?: any): Usuario {
    return new Usuario(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/usuario.ts